import React, { useState, useEffect } from 'react'
import { Form, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import DisplayMessage from '../components/DisplayMessage'
import config from '../config/config'
import { isPasswordComplexityOK } from '../utils/security'
import { LOGIN_PATH } from '../config/routes'
import { useWebsite, setFlashMessage } from '../contexts/WebsiteContext'
import PageHeroTitle from '../components/PageHeroTitle'
import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'

const ForgottenPassword = () => {
  const { t } = useTranslation()

  const [password, setPassword] = useState('')
  const [displayMessage, setDisplayMessage] = useState([])
  const [resetPasswordToken, setResetPasswordToken] = useState('')
  const [isPasswordError, setIsPasswordError] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const tokenFromUrl = urlParams.get('reset-password-token')
    if (tokenFromUrl) {
      setResetPasswordToken(tokenFromUrl)
    }
  }, [])

  const handleSendResetLink = async (e) => {
    e.preventDefault()
    setDisplayMessage([])
    setIsPasswordError(false)

    if (!isPasswordComplexityOK(password)) {
      setIsPasswordError(true)
      return
    }

    try {
      const response = await fetch(`${config.apiUrl}user/password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password, resetPasswordToken }),
      })

      if (response.ok) {
        setFlashMessage(t('PASSWORD_CHANGE_SUCCESS_MESSAGE'), 'success')
        setIsSuccess(true)
      } else {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
      }
    } catch (error) {
      setFlashMessage(t('ERROR_MESSAGE'), 'error')
    }
  }

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle title={t('FORGOTTEN_PASSWORD_TITLE')} description="" />

      <div
        className="block-wrapper mt-4"
        style={{ maxWidth: '400px', margin: 'auto' }}
      >
        {isSuccess ? (
          <div className="text-center" style={{ marginBottom: '60px' }}>
            <p>{t('PASSWORD_CHANGE_SUCCESS_MESSAGE')}</p>
            <Link to={LOGIN_PATH} className="forgot-password-link">
              {t('LOGIN_LOGIN')}
            </Link>
          </div>
        ) : (
          <>
            {displayMessage && displayMessage.length > 0 && (
              <DisplayMessage
                message={displayMessage[0]}
                messageType={displayMessage[1]}
              />
            )}
            <p>{t('FORGOTTEN_PASSWORD_DESCRIPTION')}</p>

            <Form
              onSubmit={handleSendResetLink}
              style={{ marginBottom: '60px' }}
            >
              <Form.Group controlId="formBasicPassword">
                <Form.Label>{t('PASSWORD')}</Form.Label>
                {isPasswordError && (
                  <DisplayMessage
                    messageType="error"
                    message={t('REGISTER_ERROR_PASSWORD')}
                  />
                )}
                <Form.Control
                  type="password"
                  placeholder={t('LOGIN_PASSWORD_PLACEHOLDER')}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>

              <div className="text-center m-3">
                <Button variant="primary" type="submit">
                  {t('SEND')}
                </Button>
              </div>

              <div className="text-center">
                <Link to={LOGIN_PATH} className="forgot-password-link">
                  {t('LOGIN_LOGIN')}
                </Link>
              </div>
            </Form>
          </>
        )}
      </div>

      <Footer />
    </div>
  )
}

export default ForgottenPassword
